// DashboardReducer.js
import { resetDashboardErrorCount } from "../../services/ErrorHandlingService";
import { FETCH_DASHBOARD_DATA_FAIL,
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS
 } from "../actions/DashboardCardType";
  
  const initialState = {
    receptionistsDashboard: [],
    telecallerDashboard: [],
    counsellorDashboard: [],
    serviceCallerDashboard: [],
    doctorDashboard: [],
    medicalDashboard:[],
  };
  
  export default function DashboardReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_DASHBOARD_DATA_REQUEST:
        return {
          ...state,
          receptionistsDashboard: [],
          telecallerDashboard: [],
          counsellorDashboard: [],
          serviceCallerDashboard: [],
          doctorDashboard: [],
          medicalDashboard:[],
        };
  
      case FETCH_DASHBOARD_DATA_SUCCESS:
        console.log("Dashboard data fetched successfully:", action.payload.data);
        return {
          ...state,
          receptionistsDashboard: action.payload.data,
          telecallerDashboard: action.payload, 
          counsellorDashboard: action.payload.data,
          serviceCallerDashboard: action.payload.data,
          doctorDashboard: action.payload.data,
          medicalDashboard:action.payload.data
        };
  
      case FETCH_DASHBOARD_DATA_FAIL:
        return {
          ...state,
          receptionistsDashboard: [],
          telecallerDashboard: [],
          counsellorDashboard: [],
          serviceCallerDashboard: [],
          doctorDashboard: [],
          medicalDashboard:[],
        };
  
      default:
        return state;
    }
  }